@if (isSpectating && spectator && user) {
  <ask-button-v2
    appearance="brand"
    size="small"
    [askDropdown]="dialog"
  >
    <app-icon name="visibility"></app-icon>
    {{ "SPECTATING_USER" | translate }}
    <app-icon name="keyboard_arrow_down"></app-icon>
  </ask-button-v2>

  <ng-template #dialog>
    <div [class]="'spectator-modal ' + theme">
      <div class="avatar-box">
        <ask-avatar
          [src]="spectator.urlAvatar"
          [name]="spectator.name"
        ></ask-avatar>

        <div class="name-box">
          <label class="label">{{ "GLOBAL_USER" | translate }}</label>
          <p class="name">{{ spectator.name }}</p>
        </div>
      </div>

      <div class="email-box">
        <label class="label">{{ "SPECTATING_USER" | translate }}</label>
        <p class="email">{{ user.email }}</p>
      </div>

      <div class="actions-box">
        <button type="button" (click)="handleEndSpectatingClick()">
          <span class="material-icons">power_settings_new</span>
          {{ "END_SPECTATING" | translate }}
        </button>
      </div>
    </div>
  </ng-template>
}
